module.exports = __webpack_public_path__ + "static/media/26UNRWA12.bb0f2d64.jpg";